import React from 'react';
import { Inbox, Plus } from 'lucide-react';
import { Action, Empty, Loading } from '../Common';
import { TicketTable } from './TicketTable';
import { useTicketLog } from '../../hooks/useTicketLog';

export const TicketResults = ({state, onCreate}: {state: ReturnType<typeof useTicketLog>; onCreate: () => void}) => {
  if (state.loading) return <Loading/>;
  if (state.filtered.length) return <TicketTable tickets={state.filtered} total={state.tickets.length} onDelete={state.setDeleting}/>;
  if (state.tickets.length) return <Empty icon={Inbox} title="No conversations match" text="Try another search or filter." action={<Action variant="outline" data-testid="tickets-clear-filters" onClick={state.clearFilters}>Clear filters</Action>}/>;
  return <Empty icon={Inbox} title="A fresh start for your support queue." text="Your first customer conversation belongs here." action={<Action variant="outline" data-testid="tickets-empty-create" onClick={onCreate}><Plus/>New ticket</Action>}/>;
};